import colors from '../options/colors'
import patterns from '../utils/patterns'

const MinutesBgPattern = (Minutes) => {
  if (
    !Minutes.mainXAxis ||
    !Minutes.mainSeries ||
    !Minutes.volumeSeries ||
    !Minutes.sma20Series
  ) {
    return
  }

  Minutes.removePatternBg()

  const sellingIndex = [],
    buyingIndex = []

  Minutes.mainSeries.yData.forEach((y, x) => {
    if (x < 99) {
      return
    }

    const currentVolume = Minutes.volumeSeries.yData[x]
    const last100VolumesAverage =
      Minutes.volumeSeries.yData
        .slice(x + 1 - 100, x + 1)
        .reduce((a, b) => a + b, 0) / 100

    if (y[3] - y[0] >= 0) {
      const sma20 =
        Minutes.sma20Series.yData[Minutes.sma20Series.xData.indexOf(x)]
      const candleBodyRatio = (y[3] - y[0]) / Math.max(y[1] - y[2], 1)

      const isBuying =
        last100VolumesAverage * 2 <= currentVolume &&
        sma20 <= y[3] &&
        candleBodyRatio >= 0.7 &&
        y[0] * 1.01 <= y[3]

      isBuying && buyingIndex.push(x)
    } else {
      const last21Candles = Minutes.mainSeries.yData.slice(x + 1 - 21, x + 1)

      const isSelling =
        last100VolumesAverage * 2 <= currentVolume &&
        patterns.isRankedByFluctuatingGapInLast20Days(7, last21Candles)

      isSelling && sellingIndex.push(x)
    }
  })

  const plotBands = patterns.getPlotBands(
    buyingIndex,
    sellingIndex,
    colors.pattern.buying,
    colors.pattern.selling
  )

  plotBands.forEach((plotBand) => {
    Minutes.mainXAxis.addPlotBand(plotBand, false)
    Minutes.patternBgIds.push(plotBand.id)
  })
}

export default MinutesBgPattern
